module.exports = __webpack_public_path__ + "static/img/5958_phase_function_Paper_Points.ba7f4b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5958_phase_function_Paper_Points.png
// module id = bNRk
// module chunks = 0